export class Awards
{
  Id: number;
  EmpCode: number;
  FinancialYear: string;
  Frequency: string;
  Award: string;
  NominatedBy: string;
  GiftPrice: string;
  Comments: string;
  Date: Date;
  CreatedDate: Date;
  CreatedBy: string;
  ModifiedBy: string;
  ModifiedDate: Date;
  Quarter: string;

}
